import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=6f1e32aa&scoped=true"
import script from "./Desk.vue?vue&type=script&lang=js"
export * from "./Desk.vue?vue&type=script&lang=js"
import style0 from "./Desk.vue?vue&type=style&index=0&id=6f1e32aa&prod&scoped=true&lang=css"
import style1 from "./Desk.vue?vue&type=style&index=1&id=6f1e32aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e32aa",
  null
  
)

export default component.exports